import { useTranslation } from 'react-i18next';
import EXTERNAL_URLS from 'constants/externalUrls';
import InfoWithTooltip from 'components/InfoWithTooltip/InfoWithTooltip';

const DashboardStatisticsBreadcrumbAdditionalContent = () => {
  const { t } = useTranslation();

  return (
    <InfoWithTooltip
      title={t('dashboard.statisticsPanelInfo', {
        chartName: t('dashboard.knowAboutUs.title'),
      })}
      link={EXTERNAL_URLS.statisticsPanelClients}
    />
  );
};

export default DashboardStatisticsBreadcrumbAdditionalContent;
